import React from 'react'
import { useTranslation } from 'next-i18next'

import { getNavigationIcon } from '@/constants/navigationAssets'

import {
  Wrapper,
  SelectedDistance,
  DropdownList,
  Placeholder,
  DropdownIcon,
  SelectedItemText,
  SortdownOption
} from '../DistanceDropdown/DistanceDropdown.styled'

import { SortType } from './Sorting.types'

interface SortDropdownUIProps {
  selectedSort: SortType
  isDropdownOpen: boolean
  sortOptions: SortType[]
  handleDropdownToggle: () => void
  handleOptionSelect: (sort: SortType) => void
}

const SortDropdownUI: React.FC<SortDropdownUIProps> = ({
  selectedSort,
  isDropdownOpen,
  sortOptions,
  handleDropdownToggle,
  handleOptionSelect
}) => {
  const { t } = useTranslation('parkings')
  const placeholderText = t('searchNearParking.distance.placeholder')

  return (
    <div>
      <Wrapper>
        <SelectedDistance onClick={handleDropdownToggle}>
          <img src={getNavigationIcon('list')} />
          {selectedSort !== undefined ? (
            //@ts-ignore
            <SelectedItemText>{t(`${selectedSort.key}`)}</SelectedItemText>
          ) : (
            <Placeholder>{placeholderText}</Placeholder>
          )}
          <DropdownIcon
            src={getNavigationIcon('dropdownIcon')}
            alt="dropdown icon"
            isOpen={isDropdownOpen}
          />
        </SelectedDistance>
        {isDropdownOpen && (
          <DropdownList round>
            {sortOptions.map(sort => (
              <SortdownOption
                key={sort.key}
                onClick={() => handleOptionSelect(sort)}
                selected={sort.type === selectedSort.type}
              >
                <>
                  {/* @ts-ignore */}
                  {t(sort.key)}
                  {sort.type === selectedSort.type && (
                    <img src={getNavigationIcon('selected')} />
                  )}
                </>
              </SortdownOption>
            ))}
          </DropdownList>
        )}
      </Wrapper>
    </div>
  )
}

export default SortDropdownUI
